module.exports = __webpack_public_path__ + "static/index/assets/img/3.f15d0747.png";